import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("EmailLogPermissions")
export class EmailLogPermissions {
    static readonly None = 0;
    static readonly View = 1;
}
